export const LOCAL_STORAGE_KEYS = {
  bugBounty: 'bug-bounty',
};
